export default __webpack_public_path__ + "static/media/clock_black.193e1e5a.svg";